import { Header } from "components/Header";
import { LanguageSelect } from "components/LanguageSelect";
import { SolutionsSelect } from "components/SolutionsSelect/SolutionsSelect";
import { MobileMenu } from "components/MobileMenu";
import { LOCALE_STRINGS } from "constants/locales";
import { HEADER_NAVIGATION } from "constants/navigation";
import { LocalizationContext } from "contexts/localizationContext";
import { getLinkToPortal } from "helpers/getLinkToPortal";
import { joinClassNames } from "helpers/joinClassNames";
import { useContext, useState } from "react";
import { Link } from "react-router-dom";

export const HeaderWithNav = () => {
  const { language } = useContext(LocalizationContext);


  const linkToPortal = getLinkToPortal(window.location.hostname);
  const path = window.location.pathname;

  const scrollPage = () => {
    const element = document.querySelector("#page");

    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  const renderLink = (route) => {
    if (route.path === "/solutions") {
      return <SolutionsSelect />;
    }

    const isCurrentPath =
      path === route.path ||
      (route.children && path.startsWith(route.path + "/"));


    const content = (
      <>
        <span>{LOCALE_STRINGS[language][route.title]}</span>
      </>
    );

    if (isCurrentPath) {
      return (
        <button
          className={joinClassNames(
            "home-page__header__nav__list-item__link",
            "head-button",
            "active-path",
            route.children && "dropdown-toggle",
          )}
          onClick={scrollPage}
        >
          {content}
        </button>
      );
    }

    return (
      <Link
        className={joinClassNames(
          "home-page__header__nav__list-item__link",
          route.children && "dropdown-toggle",
        )}
        rel="noopener noreferrer"
        to={`${route.path}#page`}
      >
        {content}
      </Link>
    );
  };

  return (
    <Header>
      <div className="header__nav">
        <nav>
          <ul className="home-page__header__nav__list">
            {HEADER_NAVIGATION.map((route) => {
              const isSolutions = route.path === "/solutions";

              return (
                <li
                  key={route.path}
                  className={joinClassNames(
                    "home-page__header__nav__list-item",
                    route.children && !isSolutions && "dropdown",
                  )}
                >
                  {renderLink(route)}

                  {route.children && !isSolutions && (
                    <div className="dropdown-menu">
                      {route.children.map((child) => {
                        const Icon = child.icon;

                        return (
                          <Link
                            key={child.path}
                            to={child.path}
                            className="dropdown-menu__item"
                          >
                            <div className="dropdown-menu__item-content">
                              {Icon && (
                                <div className="dropdown-menu__icon">
                                  <Icon />
                                </div>
                              )}

                              <div>
                                <div className="dropdown-menu__title">
                                  {LOCALE_STRINGS[language][child.title]}
                                </div>

                                {child.description && (
                                  <div className="dropdown-menu__description">
                                    {LOCALE_STRINGS[language][child.description]}
                                  </div>
                                )}
                              </div>
                            </div>
                          </Link>
                        );
                      })}
                    </div>
                  )}
                </li>
              );
            })}
          </ul>
        </nav>
      </div>

      <div className="header__actions">
        <div className="header__actions__language">
          <LanguageSelect />
        </div>

        <Link className="header__actions__login" to={linkToPortal}>
          {LOCALE_STRINGS[language].login}
        </Link>

        <MobileMenu />
      </div>
    </Header>
  );
};